module.exports = __webpack_public_path__ + "static/media/filename (11).dd441040.png";